import { Form, Button, Divider, InputGroup, useToaster ,Message, Checkbox, Container, Content, Stack, Panel, FlexboxGrid, Col, ButtonGroup } from 'rsuite';
import { Link, useNavigate } from 'react-router-dom';
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';
import AvatarIcon from '@rsuite/icons/legacy/Avatar';
import './style.css'
import img from './erp.png';
import background from "./p.jpg";
import React,{useEffect } from 'react';

const styles = {
  width: '100%'
};

const CustomButtonGroup = ({ appearance }) => (
  <ButtonGroup style={{ marginTop: 80 }} justified>
    <Button appearance={appearance} color='cyan' type="submit">Log In</Button>
  </ButtonGroup>
);

const SignUp = () => {

  const [formValue, setFormValue] = React.useState<{username: string; password: string; rememberMe: boolean }>({
    username: '',
    password: '',
    rememberMe: false
  });
  const [formError, setFormError] = React.useState({});
  const [loginError, setLoginError] = React.useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const rememberMeStatus = localStorage.getItem('rememberMeStatus');
    const storedUsername = localStorage.getItem('rememberMeUsername');

    if (rememberMeStatus === 'true' && storedUsername) {
      setFormValue((prevFormValue) => ({
        ...prevFormValue,
        username: storedUsername,
        rememberMe: true
      }));
    }
  }, []);

  const handleFormChange = (value) => {
    setFormValue(value);
  };

  const handleFormSubmit = async (value, event) => {
    event.preventDefault();

    const { username, password, rememberMe  } = formValue;
    const url = `http://192.168.1.83:1337/api/user-details?populate=*&filters[Username][$eq]=${encodeURIComponent(
      username
    )}&filters[Password][$eq]=${encodeURIComponent(password)}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (response.ok && data.data && data.data.length > 0) {
        const user = data.data[0];
        // Successful login
        toaster.push(message, { placement })
        console.log('Login successful!');
        console.log('User details:', user.attributes);
        if (rememberMe) {
          localStorage.setItem('rememberMeStatus', 'true');
          localStorage.setItem('rememberMeUsername', username);
        } else {
          localStorage.removeItem('rememberMeStatus');
          localStorage.removeItem('rememberMeUsername');
        }
        // Redirect the user to the dashboard page or perform any additional actions
        navigate('/dashboard');
      } else {
        // Failed login
        console.log('Invalid username or password.');
        setLoginError('Invalid username or password.');
      }
    } catch (error) {
      console.log('An error occurred during login:', error);
      // Handle any network or server errors
      setLoginError('An error occurred during login.');
    }
  };


  const [visible, setVisible] = React.useState(false);
  const handleChangeVisibility = () => {
    setVisible(!visible);
  };

  const message = (
    <Message showIcon type='success' closable>
      Login Successfully.
    </Message>
  );

  const [placement, setPlacement] = React.useState('topEnd');
  const toaster = useToaster();

  return (
    <>
      <Container className='login' style={{ 'width': '60%', 'marginLeft': '20%', 'marginTop': '30px' }}>
        <Content style={{ 'display': 'flex', 'backgroundColor': '#fff', 'boxShadow': '0px 0px 3px -1px', 'borderRadius': '5px' }}>
          <FlexboxGrid justify="space-between">
            <FlexboxGrid.Item as={Col} colspan={24} md={12} className='cool'>
              <img src={background} style={{ 'maxWidth': '100%', }} />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={12} className='cool1'>
              <div style={{ 'width': '35%', 'marginLeft': '33%', 'marginTop': '5%' }}>
                <img style={{ 'marginTop': '40%', width: '100%' }} src={img} />
              </div>
              <Divider style={{ 'marginTop': '20%' }}>Log In With User ID</Divider>
              <Panel>
                <Form fluid formValue={formValue} formError={formError} onChange={handleFormChange} onSubmit={handleFormSubmit}>
                  <Form.Group>
                    <Form.ControlLabel>Username</Form.ControlLabel>
                    <InputGroup inside style={styles}>
                    <InputGroup.Addon>
                        <AvatarIcon />
                      </InputGroup.Addon>
                      <Form.Control name="username" />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group>
                    <Form.ControlLabel>Password</Form.ControlLabel>
                    <InputGroup inside>
                    <Form.Control name="password" type={visible ? 'text' : 'password'} />
                    <InputGroup.Button onClick={handleChangeVisibility}>
                      {visible ? <EyeIcon /> : <EyeSlashIcon />}
                    </InputGroup.Button>
                  </InputGroup>
                    <Stack direction='row-reverse'>
                        <Checkbox name="rememberMe"><a>Remember Me</a></Checkbox>
                      </Stack>
                  </Form.Group>
                    <CustomButtonGroup appearance="primary" />
                </Form>
                <Stack justifyContent='center'>
                {loginError && <div className="error-message" style={{color:"red"}}>{loginError}</div>}
                </Stack>
              </Panel>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Content>
      </Container>
    </>
  );
};

export default SignUp;
